import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './OrchestraMatrixWsy.html?raw';
import connect from 'dojo/_base/connect';
import domGeom from 'dojo/dom-geometry';
import query from 'dojo/query';
import on from 'dojo/on';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import "../../moreCore/UI/SelectBox/SelectBox";
import "../../moreCore/UI/Button/Button";

import Edit from '../../moreCore/UI/Edit/Edit';
import "../../moreCore/UI/Edit/Edit";

import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import SelectionStateManagerV2 from './SelectionStateManagerV2/SelectionStateManagerV2';
import FileTileWidget from '../DashboardWidgets/FileTileWidget';

import "../SharedTypes/mixed";
import FloatingMenu from '../../moreCore/UI/Floating/Menu';

import ContentCellEditor from './ContentCellEditor/ContentCellEditor';
import "./ContentCellEditor/ContentCellEditor";
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";

import "./OrchestraMatrixWsyTypes";
import { ColorHelpers, StringHelpers } from "../../more/Helpers";

class OrchestraMatrixWsy extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    selectionValueSelector: MdsLax<InstanceType<typeof SelectBox>>;

    dataStatusLabel: HTMLSpanElement;
    y_Axis: HTMLDivElement;
    y_Axis_VirtualScrollContainer: HTMLDivElement;
    x_Axis: HTMLDivElement;
    x_Axis_ScrollContainer: HTMLDivElement;
    viewPortNode: HTMLDivElement;
    containerNode: HTMLDivElement;
    globalSumrows_values: HTMLDivElement;
    globalSumrows_labels: HTMLDivElement;

    // Anmerkungsspalte (ganz rechts, pro Zeile ein Textfeld) -- siehe _processData_Y / _onNoteChange
    notes_Header: HTMLDivElement;
    notes_Axis: HTMLDivElement;
    notes_Sum_Spacer: HTMLDivElement;

    selectionValue: OrchestraMatrixWsy_SelectionValueEntity = null;
    fileTileWidget: MdsLax<InstanceType<typeof FileTileWidget>>;

    __opacityTimeout: number;
    __mapContentTimeout: number;
    //__scrollTimeout: number;

    _mousePressActive: boolean = false;
    _lastMouseactiveCellEntry: OrchestraMatrixWsy_cellEntry = null;

    _viewPortObserver: IntersectionObserver = null;
    protected _visibleCells_X: Array<Element> = [];

    readonly: boolean = false;

    maxRows: number = 0;
    maxCells: number = 0;
    cellHeight: number = 35;
    cellWidth: number = 35;
    cellBorder: object = {
        "left": 0,
        "right": 1,
        "top": 1,
        "bottom": 0,
        "color": "gray",
        "style": "dotted"
    };
    cellBorderBold: object = {
        "left": 0,
        "right": 1,
        "top": 1,
        "bottom": 0,
        "color": "black",
        "style": "solid"
    };
    colors: object = { // farben der Contentcells
        "entity": "#FFFFFF",
        "group": "#ededeb"
    };
    OpacityScroll: boolean = false; // abblenden während dem Scrollen

    _data_Content: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_Content>;
    _data_X: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_X>;
    _data_Y: OrchestraMatrixWsy_ItemContainer<OrchestraMatrixWsy_DataItem_Y>;
    _data_SelectionValues: Array<OrchestraMatrixWsy_SelectionValueEntity>;

    _gridRows: Record<string, OrchestraMatrixWsy_rowEntry>;
    _cells: Record<string, OrchestraMatrixWsy_cellEntry>;
    _registry_X: Array<OrchestraMatrixWsy_DataItem_X> = new Array<OrchestraMatrixWsy_DataItem_X>();
    _registry_Y: Array<OrchestraMatrixWsy_DataItem_Y> = new Array<OrchestraMatrixWsy_DataItem_Y>();

    _nodeToDataItem: Array<{ node: HTMLElement, item: OrchestraMatrixWsy_DataItem, noteNode?: HTMLElement }> = [];

    // moreCore-Edit-Instanzen der Anmerkungsspalte (eine pro entity-Zeile). Muss vor jedem
    // empty(notes_Axis) explizit destroy()t werden (domConstruct.empty zerstoert Widgets nicht).
    _noteEdits: any[] = [];
    // Gestagte Anmerkungs-Aenderungen (bookingID -> {yItem, Edit}); gespeichert/verworfen ueber Speichern/Verwerfen.
    _dirtyNotes: Record<string, { yItem: OrchestraMatrixWsy_DataItem_Y, noteEdit: any }> = {};

    // Spalten-Einrasten (siehe refreshViewPortContent): beim ersten Lauf aus den CSS-% erfasst,
    // damit das HTML die alleinige Quelle fuer das Mitte/Anmerkung-Verhaeltnis bleibt (resize-fest).
    _notesSpanFraction: number = null;   // (viewPortNode + notes_Axis) / Bandbreite
    _notesMidFraction: number = null;    // viewPortNode / (viewPortNode + notes_Axis)

    _visibleIDs_X: Record<number, string>;
    _visibleIDs_Y: Record<number, string>;

    _visibleItems_X: Record<number, OrchestraMatrixWsy_DataItem_X>;
    _visibleItems_Y: Record<number, OrchestraMatrixWsy_DataItem_Y>

    _nodes_X: Array<HTMLElement> = new Array<HTMLElement>();
    _nodes_Y: Array<HTMLElement> = new Array<HTMLElement>();

    selectionStateManager: MdsLax<InstanceType<typeof SelectionStateManagerV2>>;

    directBookingId: string;
    directProjectId: string;

    mainMenuGlobalSpaceNode: HTMLElement;

    private _collapsedItems_Y: Array<{ node: HTMLElement, item: OrchestraMatrixWsy_DataItem }> = [];
    private _collapsedItems_X: Array<OrchestraMatrixWsy_DataItem> = [];

    private uniqueColors: Array<string> = [
        "#E6194B", "#3CB44B", "#0082C8", "#F58231", "#911EB4",
        "#46F0F0", "#F032E6", "#D2F53C", "#FABEBE", "#008080",
        "#ffff66", "#AA6E28", "#FFD8B1", "#A9A9A9", "#DCBEFF"
    ];

    // global (nicht mehr pro Gruppe); -1 damit der erste ++ auf Slot 0 landet
    private uniqueColorIndex: number = -1;

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

        this.SEDconfigCallfunction = "Webtool_API_MatrixView_WSY__GetSEDConfig";

        this.RequestManager.handleAs = "json";
        this.refreshViewPortContent();

        this._subscriptions.push({
            handle: connect.connect(window, "resize", this, "refreshViewPortContent"),
            topic: "windowResize"
        });

        this.addSubscription("sidebar/opened", lang.hitch(this, this.refreshViewPortContent));
        this.addSubscription("sidebar/closed", lang.hitch(this, this.refreshViewPortContent));

        this.loadData();

        if (this.mainMenuGlobalSpaceNode == null) {
            this.mainMenuGlobalSpaceNode = document.getElementById("mainMenuGlobalSpace");
        }

    }

    getItemX(ID: string) {
        for (let i = 0; i < this._registry_X.length; i++) {
            let item = this._registry_X[i];

            if (item.ID == ID) {
                return item;
            }
        }
        return null;
    }

    getItemY(ID: string) {
        for (let i = 0; i < this._registry_Y.length; i++) {
            let item = this._registry_Y[i];

            if (item.ID == ID) {
                return item;
            }
        }
        return null;
    }

    getScrollOffsetIndex_X(): number {
        let firstVisibleItem = this._visibleItems_X[0];
        return this._registry_X.indexOf(firstVisibleItem);
    }

    getScrollOffsetIndex_Y(): number {
        let firstVisibleItem = this._visibleItems_Y[0];
        return this._registry_Y.indexOf(firstVisibleItem);
    }

    startViewportObserver(): void {

        let cellNodes = this._nodes_X;
        if (cellNodes.length == 0) {
            return;
        }

        let threshold = 0.8;

        if (this._viewPortObserver != null) {
            this._viewPortObserver.disconnect();
            this._viewPortObserver = null;
        }

        this._viewPortObserver = new IntersectionObserver(lang.hitch(this, this._viewportObserverCallback), {
            threshold: [threshold]
        });


        cellNodes.forEach((node: Element) => {
            this._viewPortObserver.observe(node);
        });
    }

    private _viewportObserverCallback(entries, observer) {

        for (let i = 0; i < entries.length; i++) {
            let entry = entries[i];

            let existingIndex = this._visibleCells_X.indexOf(entry.target);

            if (entry.isIntersecting) {
                if (existingIndex == -1) {
                    this._visibleCells_X.push(entry.target);
                }
            }
            else {
                if (existingIndex > -1) {
                    this._visibleCells_X.splice(existingIndex, 1);
                }
            }
        }
    }

    private _selectedMonthId: string = null;
    private _selectedFunctionalGroupId: string = null;

    loadData(): void {

        if (this._selectedMonthId == null) {
            this.openSelectEntityDialog(null, "selectMonth", lang.hitch(this, this._onSEDCallback));
            return;
        }
        if (this._selectedFunctionalGroupId == null) {
            this.openSelectEntityDialog(null, "selectFunctionalGroup", lang.hitch(this, this._onSEDCallback));
            return;
        }

        this.StandbyStart();
        this.clear();
        //this.load_Content();
        this.load_X();
        this.load_Y();
        this.load_SelectionValues();
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<more.EntityAPIResultExtendedGDisp1 | { value: string, label: string }>>) {
        switch (mode) {
            case "selectMonth":
                if (items && items.length > 0) {
                    for (let item of items) {
                        let entity = item.entry.data as more.EntityAPIResultExtendedGDisp1;
                        console.log("selectMonth", entity);

                        this._selectedMonthId = item.entry.value;
                        this.loadData();
                    }
                }
                break;
            case "selectFunctionalGroup":
                if (items && items.length > 0) {
                    for (let item of items) {
                        let entity = item.entry.data as more.EntityAPIResultExtendedGDisp1;
                        console.log("selectFunctionalGroup", entity);

                        this._selectedFunctionalGroupId = item.entry.value;
                        this.loadData();
                    }
                }
                break;
        }
    }

    checkLoadingState(): void {

        if (this._data_Content == null && this._data_X != null && this._data_Y != null) {
            // X und Y vorhanden, aber content fehlt noch
            this.load_Content();
            return;
        }

        if (this._data_Content != null && this._data_X != null && this._data_Y != null) {
            // alles vorhanden. dann kann mit dem initialien zeichnen der DAten begonnen werden
            this.calcVisibleIds();
            this.mapDataToViewPort();
            this.refreshViewPortContent();
            this.StandbyStop();

            if (this._scrollRestoreY != null) {
                this.y_Axis.scrollTop = this._scrollRestoreY;   // Save/Rollback/Berechnen: Position halten
                this._scrollRestoreY = null;
            } else {
                this.y_Axis.scrollTop = 0;                      // Erst-/Neu-Load: nach oben
            }
        }
    }

    _onClick_LoadContentCellsButton(): void {
        this.StandbyStart();
        this._scrollRestoreY = this.y_Axis.scrollTop;   // same-data Reload -> Scrollposition halten
        this.load_Content();
    }

    selectionStateManager_Rollback(): void {
        if (confirm(this.getTranslation("OM_Matrix__RollbackMsg"))) {
            this.StandbyStart();
            this._scrollRestoreY = this.y_Axis.scrollTop;   // same-data Reload -> Scrollposition halten
            this._revertNotes();                            // Anmerkungsfelder auf gespeicherten Stand (nichts geschrieben)
            this.load_Content();

            this.selectionStateManager.ClearStack();
        }
    }
    selectionStateManager_BeforeCommit(): void {
        this.StandbyStart();
    }

    selectionStateManager_Commit(result: boolean): void {
        if (result == true) {
            let hadContent = this.selectionStateManager.stack.length > 0;   // vor ClearStack pruefen
            this.selectionStateManager.ClearStack();

            if (hadContent) {                               // nur bei echter Inhaltsaenderung neu laden
                this._scrollRestoreY = this.y_Axis.scrollTop;   // same-data Reload -> Scrollposition halten
                this.load_Content();
            }
            this._commitNotes();                            // gestagte Anmerkungen im Batch speichern
        }

        this.StandbyStop();
    }


    private __load_Content_InProgress: boolean = false;

    load_Content(): void {

        if (this.__load_Content_InProgress == true) {
            return;
        }

        this.__load_Content_InProgress = true;
        let requestData: object = {
            "IDsX": this._getAxisIDs(this._registry_X),
            "IDsY": this._getAxisIDs(this._registry_Y),
        };

        this.RequestManager.callfunction("Webtool_API_MatrixView_WSY__ContentCells",
            requestData,
            lang.hitch(this, function (response) {
                this.__load_Content_InProgress = false; // inline wahnsinn!!!!!
                // Farben (uniqueColorIndex + _pairColors) NICHT zurücksetzen:
                // pro pairKey stabil über Reload/Save, damit Farben nicht springen und nicht kollidieren
                this._data_Content = response;
                this._processData_Content();
            }), function (err) {
                this.__load_Content_InProgress = false;
            },
            false,
            { skipXssCheck: true }
        );
    }

    _getAxisIDs(axisRegistry: Array<OrchestraMatrixWsy_DataItem_Axis>): Array<object> {
        let resultList: Array<object> = new Array<object>();

        for (let i = 0; i < axisRegistry.length; i++) {
            let entry: OrchestraMatrixWsy_DataItem_Axis = axisRegistry[i];

            if (entry.type == "entity") { // braucht man das?? eventuell blöd bei Summenzeilen
                resultList.push(entry);
            }
        }

        return resultList;
    }

    _processData_Content(): void {
        /*this.UiModder.domAttr.set(this.dataStatusLabel, {
            "innerHTML": "content data loaded",
            "style": {
                "color": "green"
            }
        });*/
        this.UiModder.domClass.add(this.dataStatusLabel, "w3-hide");

        this.checkLoadingState();
    }

    load_SelectionValues(): void {

        this.RequestManager.callfunction("Webtool_API_MatrixView_WSY__GetSelectionValues",
            null,
            lang.hitch(this, this._processSelectionValues),
            function (err) {
                alert(JSON.stringify(err));
            }
        );
    }

    _processSelectionValues(items: Array<OrchestraMatrixWsy_SelectionValueEntity>) {
        this._data_SelectionValues = items;
        if (this.selectionValueSelector.entries.length == 0) {
            for (let entity of this._data_SelectionValues) {
                this.selectionValueSelector.addOption(entity.ID, entity.code, true);
            }
        }

        this.selectionValueSelector.startup();
        this.refreshSelectionValue();
    }

    getSelectionValueEntityByID(ID: string) {
        for (let entity of this._data_SelectionValues) {
            if (entity.ID == ID) {
                return entity;
            }
        }
        return null;
    }

    load_Y(): void {

        this.RequestManager.callfunction("Webtool_API_MatrixView_WSY__GetData_Y",
            {
                "functionalGroupId": this._selectedFunctionalGroupId,
                //"monthId": "000001d8:00000119"
                "monthId": this._selectedMonthId
            },
            lang.hitch(this, function (response) {
                this._data_Y = response;
                this._processData_Y();
                this.checkLoadingState();
            }), function (err) { alert(JSON.stringify(err)); }
        );
    }

    _redrawY(): void {
        this._registry_Y = [];

        // Anmerkungs-Edits zerstoeren bevor der Container geleert wird (empty() zerstoert Widgets nicht)
        this._noteEdits.forEach((e) => e.destroy());
        this._noteEdits = [];

        this.UiModder.domConstruct.empty(this.y_Axis);
        this.UiModder.domConstruct.empty(this.y_Axis_VirtualScrollContainer);
        this.UiModder.domConstruct.empty(this.notes_Axis);

        this._processData_Y();
    }

    private _adjustCollapsableIcon(iconNode: HTMLElement, collapsed: boolean) {

        if (this.UiModder.domClass.contains(iconNode, "collapseIconX")) {
            if (collapsed == true) {
                this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-right");
                this.UiModder.domClass.add(iconNode, "fa-chevron-circle-left");
            } else {
                this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-left");
                this.UiModder.domClass.add(iconNode, "fa-chevron-circle-right");
            }
        } else if (this.UiModder.domClass.contains(iconNode, "collapseIconY")) {
            if (collapsed == true) {
                this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-up");
                this.UiModder.domClass.add(iconNode, "fa-chevron-circle-down");
            } else {
                this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-down");
                this.UiModder.domClass.add(iconNode, "fa-chevron-circle-up");
            }
        }
    }

    // click vertial (auf-/zuklappen)
    //
    _onClick_yItem(item: OrchestraMatrixWsy_DataItem_Y, node: HTMLElement, evt: Event) {
        //console.log("_onClick_yItem", item);

        let iconNode = node.getElementsByClassName("collapseIconY")[0];
        //console.log("iconNode", iconNode);

        if (!iconNode || item.type != "group") return;

        if (item.type == "group") {

            let groupItems: Array<OrchestraMatrixWsy_DataItem> = [];
            item.collapsed = item.collapsed !== true;

            for (let i = 0; i < this._nodeToDataItem.length; i++) {
                let entry = this._nodeToDataItem[i];

                if (entry.item["groupID"] == item.ID) {
                    groupItems.push(entry.item);

                    let alreadyHidden = this.isNodeHidden(entry.node);

                    if (alreadyHidden === true) {
                        let index = this._collapsedItems_Y.indexOf(entry);
                        this._collapsedItems_Y.splice(index, 1);

                        entry.item.invisible = false;
                    } else {
                        this._collapsedItems_Y.push(entry);
                        entry.item.invisible = true;

                    }

                    this.hideNode(entry.node, entry.item.invisible);
                    if (entry.noteNode) this.hideNode(entry.noteNode, entry.item.invisible);   // Anmerkungszelle im Gleichschritt aus-/einblenden
                }
            }

            //this.mapDataToViewPort();
            
            this.refreshViewPortContent();
            //console.log("groupItems", groupItems);

            this._adjustCollapsableIcon(iconNode as HTMLElement, item.collapsed === true);
        }
    }

    _onClick_xAxis(item: OrchestraMatrixWsy_DataItem_X, node: HTMLElement, evt): void {
        console.log("_onClick_xAxis", item);

        let iconNode = node.getElementsByClassName("collapseIconX")[0];
        console.log("iconNode", iconNode);

        if (item.type == "group") {

            let groupItems = [];

            this._registry_X
            for (let i = 0; i < this._registry_X.length; i++) {
                let subItem = this._registry_X[i];
                let node = this._nodes_X[i];

                if (subItem["groupID"] == item.ID) {
                    groupItems.push(subItem);

                    let alreadyHidden = this.isNodeHidden(node);

                    if (alreadyHidden === true) {
                        let index = this._collapsedItems_X.indexOf(subItem);
                        this._collapsedItems_Y.splice(index, 1);

                        subItem.invisible = false;
                    } else {
                        this._collapsedItems_X.push(subItem);
                        subItem.invisible = true;

                    }


                    this.hideNode(node, subItem.invisible);
                }
            }

            //this._adjustCollapsableIcon(iconNode as HTMLElement, groupItems[0].invisible == true);
            this.refreshViewPortContent();
            console.log("groupItems", groupItems);
        }

    }

    _processData_Y(): void {
        //	Zeichnen der Zeilen (vertikal)
        //
        //let paddingLeft = 0;
        this._nodes_Y = new Array<HTMLElement>();
        this._noteEdits = [];   // Edit-Widgets werden hier neu aufgebaut (Zerstoerung der alten: clear()/_redrawY)
        this._dirtyNotes = {};  // gestagte Anmerkungen zeigen auf die alten Edits -> beim Neuaufbau verwerfen
        if (this.selectionStateManager) this.selectionStateManager.setNotesDirty(false);

        let lastType = null;
        let previousGroup: OrchestraMatrixWsy_DataItem_Axis;
        for (let i = 0; i < this._data_Y.items.length; i++) {

            let yItem = this._data_Y.items[i];
            let currentType = yItem.type;
            let nextType = this._data_Y.items[i + 1]?.type;

            ////	beim Wechsel von Entity auf Gruppe den Einzug zurücksetzen
            ////
            //if (currentType == "group" && lastType == "entity") {
            //	paddingLeft = 0;
            //}

            let icon = "";
            if (currentType == "group" && nextType == "entity") {
                icon = `<i class="fas fa-chevron-circle-up collapseIconY"></i>&nbsp;`;
            }

            if (currentType == "entity" && !!previousGroup) {
                previousGroup.children[i] = yItem;
            } else if (currentType == "group") {
                previousGroup = yItem;
                yItem.children = {};
            }

            let node = this.UiModder.domConstruct.create("div", {
                "innerHTML": icon + yItem.label,
                "className": "yCell" + " matrixYelement " + currentType,
                "style": {
                    "height": (this.cellHeight) + "px",
                    "borderLeft": this.getCellBorderStyleString("left"),
                    "borderRight": this.getCellBorderStyleString("right"),
                    "borderTop": this.getCellBorderStyleString("top"),
                    "borderBottom": this.getCellBorderStyleString("bottom"),
                    //"backgroundColor": (typeof (item.color) == "string" ? item.color : this.colors[currentType]),
                    "paddingLeft": (currentType == "entity") ? "16px" : "4px"
                }
            }, this.y_Axis);

            node.setAttribute("data-y", i.toString());

            ColorHelpers.colorNode(node, null, (typeof (yItem.color) == "string" ? yItem.color : this.colors[currentType]));

            on(node, "click", lang.hitch(this, this._onClick_yItem, yItem, node));

            this._nodes_Y.push(node);
            this._registry_Y.push(yItem);

            // Anmerkungszelle (rechte Spalte) fuer diese Zeile -- gleiche Hoehe/Border wie die
            // y_Axis-Zeile (kein box-sizing, damit die 35px Content-Hoehe + 1px Top-Border zur
            // Zeilenhoehe im Grid passt und nichts verrutscht).
            let noteNode = this.UiModder.domConstruct.create("div", {
                "className": "noteCell " + currentType + (currentType == "entity" ? "" : " noteCellDisabled"),
                "style": {
                    "height": (this.cellHeight) + "px",
                    "borderTop": this.getCellBorderStyleString("top"),
                    "borderBottom": this.getCellBorderStyleString("bottom")
                }
            }, this.notes_Axis) as HTMLElement;

            // nur Buchungszeilen (entity) bekommen ein Textfeld; Gruppen-/Number-Zeilen bleiben leer,
            // werden wie die Zeile eingefaerbt (coloredNode) und per not-allowed-Cursor als gesperrt markiert
            if (currentType == "entity") {
                let noteEdit: any = new Edit();
                noteEdit.placeAt(noteNode);
                noteEdit.startup();
                noteEdit.setValue(yItem.note || "", true);   // seed OHNE change-Event (2. Arg = suppress)
                noteEdit.on("change", lang.hitch(this, this._onNoteChange, yItem, noteEdit));
                this._noteEdits.push(noteEdit);
            } else {
                ColorHelpers.colorNode(noteNode, null, (typeof (yItem.color) == "string" ? yItem.color : this.colors[currentType]));
            }

            this._nodeToDataItem.push({
                node: node,
                item: yItem,
                noteNode: noteNode
            });

            // dummy-node in scrollcontainer erstellen
            // 	y_Axis_ScrollContainer hat einen Inhalt der gleich groß ist wie der Inhalt von y_Axis. Jedoch ist de Inhalt von y_Axis_ScrollContainer unsichtbar und dient nur dazu um einen Scrollbalken zu zeichnen
            //	die Scrollposition von y_Axis_ScrollContainer wird dann auf y_Axis übertragen
            //
            this.UiModder.domConstruct.create("div", {
                "innerHTML": "dummy",
                "style": {
                    "height": (this.cellHeight) + "px",
                    "borderLeft": this.getCellBorderStyleString("left"),
                    "borderRight": this.getCellBorderStyleString("right"),
                    "borderTop": this.getCellBorderStyleString("top"),
                    "borderBottom": this.getCellBorderStyleString("bottom"),
                    "visibility": "hidden"
                }
            }, this.y_Axis_VirtualScrollContainer);

            ////	nach jeder gruppe den linken Einzug vergrößern
            ////
            //if (currentType == "group") {
            //	paddingLeft += 16;
            //}

            lastType = currentType;
        }

        for (let map of this._nodeToDataItem) {
            if (map.item.type == "group" && map.item.collapsed === true) {
                this._onClick_yItem(map.item as any, map.node, null);
            }
        }

        this.checkLoadingState();
    }

    load_X(): void {
        this.RequestManager.callfunction("Webtool_API_MatrixView_WSY__GetData_X",
            {
                "functionalGroupId": this._selectedFunctionalGroupId,
                "monthId": this._selectedMonthId
            },
            lang.hitch(this, function (response) {
                this._data_X = response;
                this._processData_X();
            }), function (err) { alert(JSON.stringify(err)); }
        );
    }

    _processData_X(): void {
        //	Zeichnen der Spalten (horizontal)
        //
        let createdCells = [];
        let width = 0;

        let segmentLineNode: HTMLDivElement = null;
        let segmentNode: HTMLDivElement = null;
        if (this._data_X.segmentLinePosition != null) { // segmente werden verwendet
            // container der segmente
            segmentLineNode = this.UiModder.domConstruct.create("div", {}) as HTMLDivElement;
            // erstes segment gleich erstellen
            segmentNode = this.UiModder.domConstruct.create("div", { "className": "w3-cell daygroupTop", "innerHTML": "&nbsp;" }, segmentLineNode) as HTMLDivElement;

        }
        // segment-line on top?
        //
        if (this._data_X.segmentLinePosition == "top") {
            this.UiModder.domConstruct.place(segmentLineNode, this.x_Axis);
        }

        let segment_1_text_old: string = undefined;
        let segmentItemCounter: number = 0;

        let segmentNodeOutputCounter = 0;

        let previousGroup: OrchestraMatrixWsy_DataItem_X;

        for (let i = 0; i < this._data_X.items.length; i++) {
            let xItem = this._data_X.items[i];
            let currentType = xItem.type;
            let nextType = this._data_X.items[i + 1]?.type;


            if (this._data_X.segmentLinePosition != null) { // segmente werden verwendet	
                // das alte segment ist zu ende und ein neues muss erstellt werden
                if (segment_1_text_old != xItem.segment_1_text) {
                    segmentNode = this.UiModder.domConstruct.create("div", {
                        "innerHTML": xItem.segment_1_text == undefined ? "" : xItem.segment_1_text,
                        "className": "w3-cell daygroupTop"
                    }, segmentLineNode) as HTMLDivElement;
                    segmentItemCounter = 1;
                    segmentNodeOutputCounter++;
                } else {
                    segmentItemCounter++;
                }

                let additionalWidth = 0;

                if (segmentNodeOutputCounter == 0) {
                    additionalWidth = 1;
                }
                let segmentWidth = (this.cellWidth * segmentItemCounter) + additionalWidth + "px";


                this.UiModder.domStyle.set(segmentNode, {
                    "width": segmentWidth,
                    "borderLeft": this.getCellBorderStyleString("left"),
                    "borderRight": this.getCellBoldBorderStyleString("right")
                });
            }

            let icon = "";
            if (currentType == "group" && nextType == "entity") {
                icon = `<i class="fas fa-chevron-circle-left collapseIconX"></i>&nbsp;`;
            }

            if (currentType != "group" && !!previousGroup) {
                previousGroup.children[i] = xItem;
            } else if (currentType == "group") {
                previousGroup = xItem;
                xItem.children = {};
            }

            let cell = this.UiModder.domConstruct.create("div", {
                "innerHTML": icon + xItem.label,
                "class": "matrixCell_TOP_X flex_row_center xCell",
                "style": {
                    //"height": "90%",
                    "width": this.cellWidth + "px",
                    "borderLeft": this.getCellBorderStyleString("left"),
                    "borderRight": this.getCellBorderStyleString("right"),
                    //"backgroundColor": (typeof (xItem.color) == "string" ? xItem.color : this.colors[currentType]),
                }
            }, this.x_Axis);

            cell.setAttribute("data-x", i.toString());

            ColorHelpers.colorNode(cell, null, (typeof (xItem.color) == "string" ? xItem.color : this.colors[currentType]));

            on(cell, "click", lang.hitch(this, this._onClick_xAxis, xItem, cell));

            createdCells.push(cell);

            width += (this.cellWidth + this.getCellBorderWidth());
            this._registry_X.push(xItem);

            segment_1_text_old = xItem.segment_1_text;
        }

        this._nodes_X = createdCells;

        // segment-line bottom?
        //
        if (this._data_X.segmentLinePosition == "bottom") {
            this.UiModder.domConstruct.place(segmentLineNode, this.x_Axis);
        }

        // gesamte Container-Breite auf die Summe der Spalten-Breite anpassen
        this.UiModder.domStyle.set(this.x_Axis, {
            "width": width + "px"
        });

        if (this._data_X.segmentLinePosition == "bottom") {
            this.x_Axis_ScrollContainer.scrollTop = 200;
        }

        this.checkLoadingState();
    }

    _lastOnClick_DataItem: OrchestraMatrixWsy_DataItem_X;
    _onClick_Dlg: MdsLax<InstanceType<typeof GenericDialog>>;

    clear(): void {
        this.UiModder.domConstruct.empty(this.x_Axis);
        this._registry_X = new Array<OrchestraMatrixWsy_DataItem_X>();

        // Anmerkungs-Edits zerstoeren bevor die Container geleert werden (empty() zerstoert Widgets nicht)
        this._noteEdits.forEach((e) => e.destroy());
        this._noteEdits = [];

        this.UiModder.domConstruct.empty(this.y_Axis);
        this.UiModder.domConstruct.empty(this.y_Axis_VirtualScrollContainer);
        this.UiModder.domConstruct.empty(this.notes_Axis);
        this._registry_Y = new Array<OrchestraMatrixWsy_DataItem_Y>();
        this._cells = {};

        this._data_Content = null;
        this._data_X = null;
        this._data_Y = null;

        this._visibleIDs_X = null;
        this._visibleIDs_Y = null;

        this._visibleItems_X = null;
        this._visibleItems_Y = null;

        this._previousRenderedIndexY = -1;   // Flicker-Guard fuer neues Dataset zuruecksetzen
    }

    calcVisibleIds(): void {
        this.calcVisibleIds_X();
        this.calcVisibleIds_Y();
    }
    private _currentStartIndexX: number = 0;
    private _currentStartIndexY: number = 0;
    private _scrollRestoreY: number = null;   // gesetzt vor Save/Rollback/Berechnen-Reload, sonst null

    calcVisibleIds_X(startIndex?): void {
        if (typeof (startIndex) == "undefined") startIndex = this._currentStartIndexX;
        if (typeof (startIndex) == "undefined") {
            startIndex = 0;
        }

        this._currentStartIndexX = startIndex;
        this._visibleIDs_X = {}
        this._visibleItems_X = {};
        let localIndex = -1;

        for (let i = 0; i < this._registry_X.length; i++) {
            if (i >= startIndex && i <= startIndex + this.maxCells) {
                let item = this._registry_X[i];
                if (!item.invisible) {
                    localIndex++;
                    this._visibleIDs_X[localIndex] = item.ID;
                    this._visibleItems_X[localIndex] = item;
                }
            }
        }
    }
    calcVisibleIds_Y(startIndex?): void {
        if (typeof (startIndex) == "undefined") startIndex = this._currentStartIndexY;
        if (typeof (startIndex) == "undefined") {
            startIndex = 0;
        }

        this._currentStartIndexY = startIndex;
        this._visibleIDs_Y = {};
        this._visibleItems_Y = {};
        let localIndex = -1;

        let globalIndexStart = -1;
        let globalIndexEnd = -1;

        for (let i = 0; i < this._registry_Y.length; i++) {
            if (i >= startIndex) {
                let item = this._registry_Y[i];
                if (!item.invisible) {
                    localIndex++;
                    this._visibleIDs_Y[localIndex] = this._registry_Y[i].ID;
                    this._visibleItems_Y[localIndex] = this._registry_Y[i];
                }
                globalIndexEnd = i;
                if (Object.keys(this._visibleIDs_Y).length >= this.maxRows) break;
            }
        }

        console.debug("calculated ACTUAL visible items Y", globalIndexStart, globalIndexEnd, this._visibleIDs_Y, this._visibleItems_Y)
    }

    private getXY(x: number, y: number): string {
        return StringHelpers.numberToString(x, 6) + ":" + StringHelpers.numberToString(y, 6);
    }

    refreshViewPortContent(): void {
        // Container leeren
        this.destroyAllRows();

        // breite vom ViewPort auslesen
        //
        let viewPortWidth = this.getViewPortSize().w;
        let viewPortHeight = this.getViewPortSize().h;

        // --- Spaltenraster auf ganze Zellen einrasten ---------------------------------------
        // Grid-Breite = Vielfaches der Zell-Teilung, damit das Grid exakt auf einer Zellgrenze
        // endet und die Anmerkungsspalte den Rest bekommt. Sonst rundet maxCells auf, und die
        // angeschnittene Rest-Zelle wird von overflow:hidden mitten durchgeschnitten und liegt
        // dann hinter dem Notizfeld. Die drei Baender (Kopf/Grid/Summen) werden synchron gesetzt.
        let pitch = this.cellWidth + this.getCellBorderWidth();
        let notesBoxW = domGeom.getMarginBox(this.notes_Axis).w;
        let bandW = domGeom.getMarginBox(this.viewPortNode.parentNode as HTMLElement).w;
        if (this._notesSpanFraction == null && bandW > 0 && viewPortWidth > 0) {
            // erster gueltiger Lauf: noch die pristinen CSS-% -> Verhaeltnisse merken (danach px-ueberschrieben)
            this._notesSpanFraction = (viewPortWidth + notesBoxW) / bandW;
            this._notesMidFraction = viewPortWidth / (viewPortWidth + notesBoxW);
        }
        let spanFrac = this._notesSpanFraction != null ? this._notesSpanFraction : ((viewPortWidth + notesBoxW) / (bandW || 1));
        let midFrac = this._notesMidFraction != null ? this._notesMidFraction : (viewPortWidth / ((viewPortWidth + notesBoxW) || 1));
        let span = bandW * spanFrac;                                 // Mitte+Anmerkung, folgt Fenster-Resize
        let gridCols = Math.max(1, Math.floor((span * midFrac) / pitch));
        let gridPx = gridCols * pitch;
        let notesPx = span - gridPx;

        this.UiModder.domStyle.set(this.viewPortNode, "width", gridPx + "px");
        this.UiModder.domStyle.set(this.x_Axis_ScrollContainer, "width", gridPx + "px");
        this.UiModder.domStyle.set(this.globalSumrows_values, "width", gridPx + "px");
        this.UiModder.domStyle.set(this.notes_Axis, "width", notesPx + "px");
        this.UiModder.domStyle.set(this.notes_Header, "width", notesPx + "px");
        this.UiModder.domStyle.set(this.notes_Sum_Spacer, "width", notesPx + "px");

        // Maximale Anzahl Zeilen/Spalten berechnen
        // floor, nicht ceil: der Y-Scroll rastet auf ganze Zeilen (siehe _handleYScroll snapTop),
        // eine aufgerundete Rest-Zeile kann also nie voll sichtbar werden -> haengt nur angeschnitten
        // unter dem overflow:hidden-Rand. floor = ganze Zeilen, kein abgeschnittener Rest unten.
        this.maxRows = Math.floor((viewPortHeight - 0) / (this.cellHeight + this.getCellBorderHeight()));
        this.maxCells = gridCols;

        this.calcVisibleIds();

        let containerHeight = 0;
        let containerWidth = 0;

        this._gridRows = {};
        this._cells = {};

        // Zeilen erzeugen
        for (let rowIndex = 0; rowIndex < this.maxRows; rowIndex++) {

            containerWidth = 0;
            let rowNode = this.UiModder.domConstruct.create("div", {
                "class": "matrixRow",
                "style": {
                    "height": (this.cellHeight + this.getCellBorderHeight()) + "px",
                    // Floats der Zellen einschliessen (BFC). Bei gebrochenem Browser-Zoom rundet die
                    // Zellhoehe minimal groesser als die Zeilenhoehe -> Zellen laufen sonst in die
                    // naechste Zeile und versetzen sie um eine Spalte (Treppen-Effekt / "faellt auseinander").
                    "overflow": "hidden"
                }
            }, this.containerNode);

            let rowEntry: OrchestraMatrixWsy_rowEntry = {
                "rowNode": rowNode as HTMLDivElement,
                "cells": []
            };

            this._gridRows[rowIndex] = rowEntry; // row to registry

            // Spalten pro Zeile erzeugen
            for (let cellIndex = 0; cellIndex < this.maxCells; cellIndex++) {
                let cellNode = this.UiModder.domConstruct.create("div", {
                    "class": "matrixCell",
                    "style": {
                        "width": this.cellWidth + "px",
                        "height": this.cellHeight + "px",
                        "borderLeft": this.getCellBorderStyleString("left"),
                        "borderRight": this.getCellBorderStyleString("right"),
                        "borderTop": this.getCellBorderStyleString("top"),
                        "borderBottom": this.getCellBorderStyleString("bottom")
                    }
                }, rowNode);

                let cellEntry: OrchestraMatrixWsy_cellEntry = {
                    "cellNode": cellNode as HTMLDivElement,
                    "entity": null,
                    "coordinatesVisible": { x: cellIndex, y: rowIndex }
                };

                let xy = this.getXY(cellIndex, rowIndex);

                cellNode.setAttribute("data-xy", xy);
                cellNode.setAttribute("data-x", cellIndex.toString());
                cellNode.setAttribute("data-y", rowIndex.toString());

                rowEntry.cells.push(cellEntry); // cell to row
                this._cells[xy] = cellEntry;

                containerWidth += (this.cellWidth + this.getCellBorderWidth());
            }

            containerHeight += (this.cellHeight + this.getCellBorderHeight());
        }

        // Container auf Inhaltsgröße anpassen
        //
        this.UiModder.domStyle.set(this.containerNode, {
            "height": containerHeight + "px",
            "width": containerWidth + "px"
        });

        this.UiModder.domStyle.set(this.y_Axis, {
            "height": containerHeight + "px"
        });
        this.UiModder.domStyle.set(this.y_Axis_VirtualScrollContainer, {
            "height": containerHeight + "px"
        });
        // Anmerkungsspalte auf denselben Scrollport wie y_Axis setzen -> 1:1 Scroll-Sync
        this.UiModder.domStyle.set(this.notes_Axis, {
            "height": containerHeight + "px"
        });

        this.mapDataToViewPort();
        //this.drawSumRows();
    }

    _resetContentOpacity(): void {
        if (this.__opacityTimeout) {
            clearTimeout(this.__opacityTimeout);
        }
        this.__opacityTimeout = setTimeout(lang.hitch(this, function () {
            this.UiModder.domStyle.set(this.containerNode, "opacity", 1);
        }), 50);
    }

    private getContentEntryByXY(xyCoord: string): OrchestraMatrixWsy_cellEntry {
        if (!xyCoord) return null;
        return this._cells[xyCoord];

        //	for (let rowIndex in this._rows) {
        //		let row = this._rows[rowIndex];
        //		for (let cellIndex = 0; cellIndex < row.cells.length; cellIndex++) {
        //			let cellEntry = row.cells[cellIndex];

        //			if (cellEntry.cellNode == cellNode) {
        //				return cellEntry;
        //			}
        //		}
        //	}
        //	return null;
    }

    drawSumRows(): void {

        this.UiModder.domConstruct.empty(this.globalSumrows_labels);
        this.UiModder.domConstruct.empty(this.globalSumrows_values);

        let sumRows = [{
            label: this.translate("OM_Matrix__SumRow_TotalCount"),
            propName: "totalCount",
            fontSize: "14px",
            height: null
        }, {
            label: this.translate("OM_Matrix__SumRow_OverLimit"),
            propName: "overLimit",
            //height: "16px",
            fontSize: "12px"
        }, {
            label: this.translate("OM_Matrix__SumRow_BelowLimit"),
            propName: "belowLimit",
            //height: "16px",
            fontSize: "12px"
        }, {
            label: this.translate("OM_Matrix__SumRow_RucksackStart"),
            propName: "rucksackStart",
            fontSize: "14px"
        }, {
            label: this.translate("OM_Matrix__SumRow_RucksackReduction"),
            propName: "rucksackReduction",
            //height: "16px",
            fontSize: "12px"
        }, {
            label: this.translate("OM_Matrix__SumRow_RucksackAddition"),
            propName: "rucksackAddition",
            //height: "16px",
            fontSize: "12px"
        }, {
            label: this.translate("OM_Matrix__SumRow_RucksackBelowLimit"),
            propName: "rucksackBelowLimit",
            fontSize: "14px"
        }, {
            label: this.translate("OM_Matrix__SumRow_RucksackEnd"),
            propName: "rucksackEnd",
            fontSize: "14px"
        }, {
            label: this.translate("OM_Matrix__SumRow_LumpSum"),
            propName: "lumpSum",
            fontSize: "14px"
        }, {
            label: this.translate("OM_Matrix__SumRow_Overtime"),
            propName: "overtime",
            fontSize: "14px"
        }];

        //this.maxCells = this.getViewPortSize().w / (this.cellWidth + this.getCellBorderWidth());

        for (let sumRowDescr of sumRows) {

            let rowLabelNode = this.UiModder.domConstruct.create("div", {
                "class": "matrixRow",
                "innerHTML": sumRowDescr.label + "&nbsp;&nbsp;",
                "style": {
                    "height": sumRowDescr.height ? sumRowDescr.height : this.cellHeight + "px",
                    "borderLeft": this.getCellBorderStyleString("left"),
                    "borderRight": this.getCellBorderStyleString("right"),
                    "borderTop": this.getCellBorderStyleString("top"),
                    "borderBottom": this.getCellBorderStyleString("bottom"),
                    "fontWeight": "bold",
                    "textAlign": "right",
                    "fontSize": sumRowDescr.fontSize
                }
            }, this.globalSumrows_labels);

            let rowNode = this.UiModder.domConstruct.create("div", {
                "class": "matrixRow",
                "style": {
                    "height": (this.cellHeight + this.getCellBorderHeight()) + "px",
                    // Floats einschliessen (BFC) -- siehe refreshViewPortContent: verhindert den
                    // Treppen-Versatz der Summenzeilen bei gebrochenem Browser-Zoom.
                    "overflow": "hidden"
                }
            }, this.globalSumrows_values);

            for (let i = 0; i < this.maxCells; i++) {
                let item_X = this._visibleItems_X[i];
                if (typeof (item_X) == "undefined") {
                    continue;
                }

                let cellNode = this.UiModder.domConstruct.create("div", {
                    "class": "matrixCell",
                    "style": {
                        "width": this.cellWidth + "px",
                        "height": sumRowDescr.height ? sumRowDescr.height : this.cellHeight + "px",
                        "borderLeft": this.getCellBorderStyleString("left"),
                        "borderRight": this.getCellBorderStyleString("right"),
                        "borderTop": this.getCellBorderStyleString("top"),
                        "borderBottom": this.getCellBorderStyleString("bottom"),
                        "fontSize": sumRowDescr.fontSize,
                        // "Rucksack per Monatsende" hervorheben: Wert-Zellen fett (Label ist bereits fett)
                        "fontWeight": sumRowDescr.propName == "rucksackEnd" ? "bold" : "normal"
                    }
                }, rowNode);

                if (item_X.type == "group") {
                    cellNode.style.background = this.colors["group"];
                } else {
                    cellNode.style.background = "";
                }

                if (sumRowDescr.propName/* && typeof (this._data_Content["globalSums"][i]) != "undefined"*/) {
                    for (let globalSumValue of this._data_Content["globalSums"]) {
                        if (globalSumValue.ref_x == item_X.ID) {
                            if (globalSumValue[sumRowDescr.propName]) {
                                let sumValue = globalSumValue[sumRowDescr.propName];
                                cellNode.innerHTML = sumValue;
                            }
                            else {
                                cellNode.innerHTML = "0";
                            }
                            break;
                        }
                    }

                }
            }
        }
    }

    _onChange_SelectionValueSelector(): void {
        this.refreshSelectionValue();
    }

    refreshSelectionValue(): void {
        this.selectionValue = this.getSelectionValueEntityByID(this.selectionValueSelector.getValue());
    }

    _onMouseDown_Content(evt): void {
        this._mousePressActive = true;
    }

    _onContextMenu_Content(evt): void {
        evt.preventDefault();
        let cellNode = evt.target as HTMLElement;
        let contentEntry: cellEntry;
        let yNode: HTMLElement;
        let xNode: HTMLElement;
        let x: string;
        let y: string;

        if (cellNode?.getAttribute) {
            let xy = cellNode.getAttribute("data-xy");
            x = cellNode.getAttribute("data-x");
            y = cellNode.getAttribute("data-y");

            contentEntry = this.getContentEntryByXY(xy);


        }

        if (!contentEntry?.entity) {
            return;
        }

        let menu = new FloatingMenu();

        menu.addEntry({
            label: this.translate("OM_Matrix__MenuItem_Edit"),
            callback: lang.hitch(this, this._MenuItem_EditContentCell, contentEntry.entity),
        });

        menu.open(evt, null);
    }

    private _contentCellForm: MdsLax<InstanceType<typeof ContentCellEditor>>;

    _MenuItem_EditContentCell(entity: OrchestraMatrixWsy_DataItem_Content) {
        console.log("edit", entity);

        let itemX = this.getItemX(entity.ref_x);
        let itemY = this.getItemY(entity.ref_y);
        console.log(itemX);
        console.log(itemY);

        this._contentCellForm = new ContentCellEditor();
        this._contentCellForm.setData(entity, this._data_X, this._data_Y, this._data_Content);

        this._contentCellForm.on("onSetScheduledMusican", lang.hitch(this, this._onSetScheduledMusican));
        this._contentCellForm.on("onSetReplacementMusican", lang.hitch(this, this._onSetReplacementMusican));

        let dlg = new GenericDialog();
        dlg.enableContentOverflow(true);
        dlg.set("callback", lang.hitch(this, this._onDlgClose));
        //dlg.destroyOnClose = false;
        dlg.show(this._contentCellForm);
    }

    _onSetScheduledMusican(dataItem: OrchestraMatrixWsy_DataItem_Content): void {
        console.log("onSetScheduledMusican", dataItem);

        if (!dataItem.ref_scheduled_musican) {
            return;
        }

        let sourceItemX = this.getItemX(dataItem.ref_x);

        let scheduledMusicanId = dataItem.ref_scheduled_musican.value;
        let scheduledMusicanItem = this.getItemX(scheduledMusicanId);

        for (let i = 0; i < this._data_Content.items.length; i++) {
            let otherItem = this._data_Content.items[i];

            if (otherItem.ref_y == dataItem.ref_y && otherItem.ref_x == scheduledMusicanItem.ID
                && otherItem.ref_scheduled_musican == null && otherItem.ref_replacement_musican == null) {  // und auch prüfen ob die gegensiete noch nicht befüllt sit damit nicht beide referenzen befüllt sind
                otherItem.ref_replacement_musican = {
                    value: sourceItemX.ID,
                    label: sourceItemX.label
                };

                this.selectionStateManager.addToStack(otherItem, "update");
            }
        }
    }

    _onSetReplacementMusican(dataItem: OrchestraMatrixWsy_DataItem_Content): void {
        console.log("_onSetReplacementMusican", dataItem);

        if (!dataItem.ref_replacement_musican) {
            return;
        }

        let sourceItemX = this.getItemX(dataItem.ref_x);
        let sourceItemY = this.getItemY(dataItem.ref_y);

        let replacementMusicanId = dataItem.ref_replacement_musican.value;
        let replacementMusicanItem = this.getItemX(replacementMusicanId);

        for (let i = 0; i < this._data_Content.items.length; i++) {
            let otherItem = this._data_Content.items[i];

            let otherItemY = this.getItemY(otherItem.ref_y);

            if (otherItem.ref_y == dataItem.ref_y && otherItem.ref_x == replacementMusicanItem.ID
                && otherItem.ref_replacement_musican == null && otherItem.ref_scheduled_musican == null) { // und auch prüfen ob die gegensiete noch nicht befüllt sit damit nicht beide referenzen befüllt sind
                otherItem.ref_scheduled_musican = {
                    value: sourceItemX.ID,
                    label: sourceItemX.label
                };

                this.selectionStateManager.addToStack(otherItem, "update");
            }
        }
    }

    _onDlgClose(): void {
        let item = this._contentCellForm.getDataItem();
        console.log("_onDlgClose", item);

        this._handleContentSelection_Update(item);
        this.refreshViewPortContent();
    }

    _onMouseUp_Content(evt): void {
        this._mousePressActive = false;

    }

    _onMouseMove_Content(evt): void {
        let cellNode = evt.target as HTMLElement;
        let contentEntry: OrchestraMatrixWsy_cellEntry;
        let yNode: HTMLElement;
        let xNode: HTMLElement;
        let x: string;
        let y: string;

        if (cellNode?.getAttribute) {
            let xy = cellNode.getAttribute("data-xy");
            x = cellNode.getAttribute("data-x");
            y = cellNode.getAttribute("data-y");

            contentEntry = this.getContentEntryByXY(xy);


        }
        if (this._mousePressActive == true && !!contentEntry) {

            //	Wenn mausklick aktiv und maus über contentcells bewegt wird, dann wird selektion ausgeführt
            //		
            if (contentEntry != this._lastMouseactiveCellEntry) {
                this._lastMouseactiveCellEntry = contentEntry;

                this._handleContentCellSelection(contentEntry);
            }
        }

        if (contentEntry != null) {
            // X
            let visibleXNode = this._nodes_X[contentEntry.coordinatesVisible.x + this.getScrollOffsetIndex_X()];
            for (let node of this._nodes_X) {
                this.UiModder.domClass.remove(node, "boxShadow");
            }
            if (visibleXNode != null) {
                this.UiModder.domClass.add(visibleXNode, "boxShadow");
            }

            // Y
            let visibleYNode = this._nodes_Y[contentEntry.coordinatesVisible.y + this.getScrollOffsetIndex_Y()];
            for (let node of this._nodes_Y) {
                this.UiModder.domClass.remove(node, "boxShadow");
            }
            if (visibleYNode != null) {
                this.UiModder.domClass.add(visibleYNode, "boxShadow");
            }
        }

    }

    _handleContentCellSelection(contentEntry: OrchestraMatrixWsy_cellEntry): void {
        if (!contentEntry?.coordinatesVisible) {
            return;
        }

        let itemX: OrchestraMatrixWsy_DataItem_X = this._visibleItems_X[contentEntry.coordinatesVisible.x];
        let itemY: OrchestraMatrixWsy_DataItem_Y = this._visibleItems_Y[contentEntry.coordinatesVisible.y];
        if (itemX == null || itemY == null) {
            return;
        }
        if (itemX.type != "entity" || itemY.type != "entity") {
            return;
        }

        //this._data_Content.items
        console.log("_handleContentCellSelection", contentEntry.entity);
        if (contentEntry.entity?.ref_scheduled_musican != null || contentEntry.entity?.ref_replacement_musican != null) {
            this.showToast(this.translate("OM_Matrix__Msg_SwapAssignmentPreventsDelete"));
            return;
        }

        if (contentEntry.entity == null) {
            //	es gibt noch kein Entity auf der Zelle die geklickt wurde. daher erzeugen
            //
            contentEntry.entity = {
                ID: null,
                color: this.selectionValue.coloration.BackColor.Hex,
                label: this.selectionValue.code,
                type: "entity",
                collapsed: null,
                ref_x: itemX.ID,
                ref_y: itemY.ID,
                _sourceItemX: itemX,
                _sourceItemY: itemY
            };

            this._data_Content.items.push(contentEntry.entity);

            this._handleContentSelection_Create(contentEntry.entity);
        } else {
            //	entity existiert schon. entfernen
            //
            this._handleContentSelection_Delete(contentEntry.entity);
            ColorHelpers.colorNode(contentEntry.cellNode, null, null, null);
            let indexInData = this._data_Content.items.indexOf(contentEntry.entity);
            this._data_Content.items.splice(indexInData, 1);
            contentEntry.entity = null;
            //delete contentEntry.entity;
        }

        this.mapDataToViewPort();
    }

    _onClick_Content(evt): void {
        if (this.readonly == true) {
            return;
        }

        //console.log("_onClick_Content", evt, evt.target);
        if (!this.UiModder.domClass.contains(evt.target, "matrixCell")) {
            return; // klick nicht auf eine zelle ausgeführt
        }
        let cellNode = evt.target as HTMLElement;;
        if (!cellNode?.getAttribute) return;
        let xy = cellNode.getAttribute("data-xy");
        if (!xy) return;
        let contentEntry = this.getContentEntryByXY(xy);

        console.debug("_onClick_Content", cellNode, contentEntry, contentEntry.coordinatesVisible);


        this._handleContentCellSelection(contentEntry);
    }

    _handleContentSelection_Create(entity: OrchestraMatrixWsy_DataItem_Content): void {
        this.selectionStateManager.addToStack(entity, "create");
    }

    _handleContentSelection_Delete(entity: OrchestraMatrixWsy_DataItem_Content): void {
        this.selectionStateManager.addToStack(entity, "delete");
    }

    _handleContentSelection_Update(entity: OrchestraMatrixWsy_DataItem_Content): void {

        this.selectionStateManager.addToStack(entity, "update");
    }

    ContentSelection_Create_Response(originEntity: OrchestraMatrixWsy_DataItem_Content, newEntity: OrchestraMatrixWsy_DataItem_Content): void {
        originEntity.ID = newEntity.ID;
    }

    ContentSelection_Create_Error(error): void {
        alert(JSON.stringify(error));
    }

    ContentSelection_Delete_Response(response): void {

    }

    ContentSelection_Delete_Error(error): void {
        alert(JSON.stringify(error));
    }

    _onScroll_Content(evt: WheelEvent): void {

        // Wheel gehoert dem Grid, nicht der Seite -> sonst scrollt die ganze Page mit
        evt.preventDefault();

        // Horizontal wenn Shift gedrueckt oder die horizontale Komponente ueberwiegt (Trackpad)
        let horizontal = evt.shiftKey || Math.abs(evt.deltaX) > Math.abs(evt.deltaY);

        if (horizontal) {
            // Shift+Wheel liefert das Delta meist auf deltaY, Trackpad auf deltaX
            let deltaX = (evt.deltaX !== 0) ? evt.deltaX : evt.deltaY;
            this.x_Axis_ScrollContainer.scrollLeft += deltaX;   // feuert _onScroll_X (snap + repaint)
        } else {
            this.y_Axis.scrollTop += evt.deltaY;                // feuert _onScroll_Y_axis (virtual-bar sync + _handleYScroll)
        }
    }

    _onScroll_X(evt): void {
        let scrollLeft = evt.target.scrollLeft;
        let cellWithWithBorder = this.cellWidth + this.getCellBorderWidth();

        let calculatedIndex = Math.round(scrollLeft / cellWithWithBorder);
        let itemIndex_firstItem = calculatedIndex;

        // aber der berechnete Startindex stimmt nicht, wenn es davor zugeklappte Elemente gibt
        // die Scrollposition kann nicht berücksichtigen, wenn ihr Rows fehlen die zugeklappt sind
        // d.h. wenn hier rauskommt wir sind in Reihe 10, dann müssen wir zuerst in der Registry prüfen wie viele Reihen Gruppen sind und was davon zugeklappt ist.
        // das kommt als Offset oben drauf
        let count = 0;
        let index = 0;
        for (let entry of this._registry_X) {
            if (index < itemIndex_firstItem) {
                if (entry.type == "group" && entry.collapsed === true) {
                    itemIndex_firstItem += Object.keys(entry.children).length;
                }
                index++;
            } else {
                break;
            }
        }

        let firstItem = this._registry_X[itemIndex_firstItem];
        let lastItem = this._registry_X[itemIndex_firstItem + this.maxCells];

        this.calcVisibleIds_X(itemIndex_firstItem);

        // scroll-step anpassen damit immer zu ganzem item gescrollt wird und nie nur ein halbes sichtbar ist
        // hier sollte noch das delty zum vorherigen scroll berechnet werden damit auch der klick auf den balken-pfeil geht
        //
        evt.target.scrollLeft = (itemIndex_firstItem) * cellWithWithBorder;

        if (this.OpacityScroll) {
            this.UiModder.domStyle.set(this.containerNode, "opacity", 0.2);
        }

        if (this.__xScrollContainerTimeout) {
            clearTimeout(this.__xScrollContainerTimeout);
        }
        this.__xScrollContainerTimeout = setTimeout(lang.hitch(this, function () {
            this.mapDataToViewPort();
        }), 50);

        this._resetContentOpacity();
    }

    _onScroll_Y_virtual(evt): void {
        //    debugger;
        if (evt.target.scrollTop == this.y_Axis.scrollTop) return;

        this.y_Axis.scrollTop = evt.target.scrollTop;

        if (this.__yScrollContainerTimeout) clearTimeout(this.__yScrollContainerTimeout);

        this.__yScrollContainerTimeout = setTimeout(lang.hitch(this, this._handleYScroll, evt), 200);

    }

    _onScroll_SumRowsY(evt): void {
        this.globalSumrows_values.scrollTop = evt.target.scrollTop;
    }

    // Mausrad ueber der Anmerkungsspalte -> Zeilen scrollen (notes_Axis hat overflow-y:hidden,
    // also kein eigenes Scrollen). Feuert _onScroll_Y_axis, das alles synchronisiert.
    _onScroll_Notes(evt: WheelEvent): void {
        evt.preventDefault();
        this.y_Axis.scrollTop += evt.deltaY;
    }

    // ---- Anmerkungen: staged wie Zellen -> speichern via "Speichern", verwerfen via "Verwerfen" ----
    // Blur/Enter schreibt NICHT mehr live, sondern merkt die Aenderung nur vor (_dirtyNotes) und
    // aktiviert die Buttons. Commit/Rollback laufen ueber selectionStateManager_Commit/_Rollback.
    _onNoteChange(yItem: OrchestraMatrixWsy_DataItem_Y, noteEdit: any): void {
        let raw = noteEdit.inputNode.value;              // Rohtext; getValue() liefert bei "" null -> nicht nutzen
        if (raw === (yItem.note || "")) {
            delete this._dirtyNotes[yItem.entityID];     // zurueck auf gespeicherten Stand -> nicht mehr dirty
        } else {
            this._dirtyNotes[yItem.entityID] = { yItem: yItem, noteEdit: noteEdit };
        }
        this.selectionStateManager.setNotesDirty(Object.keys(this._dirtyNotes).length > 0);
    }

    // Gestagte Anmerkungen in EINEM Batch-Call speichern (CommitRowNotes). Unabhaengig von CommitContent.
    _commitNotes(): void {
        let entries = Object.keys(this._dirtyNotes).map((id) => this._dirtyNotes[id]);
        if (entries.length === 0) return;

        // Wert zum Sendezeitpunkt einfrieren (falls der User waehrend des Requests weiter tippt)
        let payload = entries.map((e) => ({
            rotation_groupID: e.yItem.rotation_groupID,
            bookingID: e.yItem.entityID,
            note: e.noteEdit.inputNode.value
        }));

        this.RequestManager.callfunction(
            "Webtool_API_MatrixView_WSY__CommitRowNotes",
            { notes: payload },                          // callfunction stringifyt das Objekt genau einmal
            lang.hitch(this, function (response) {
                // Erfolg: Backend liefert {} (handleAs="json" -> leeres Objekt; roh "{}").
                let ok = response === "{}"
                    || (response && typeof response === "object" && Object.keys(response).length === 0);
                if (!ok) { this._onNotesCommitError(response); return; }

                for (let i = 0; i < entries.length; i++) {
                    let e = entries[i];
                    e.yItem.note = payload[i].note;      // Basiswert = gespeicherter Wert
                    // nur entfernen, wenn seit dem Absenden nicht weiter getippt wurde
                    if (this._dirtyNotes[e.yItem.entityID] === e && e.noteEdit.inputNode.value === payload[i].note) {
                        delete this._dirtyNotes[e.yItem.entityID];
                    }
                }
                this.selectionStateManager.setNotesDirty(Object.keys(this._dirtyNotes).length > 0);
            }),
            lang.hitch(this, this._onNotesCommitError)   // Transport-/HTTP-Fehler
        );
    }

    _onNotesCommitError(detail: any): void {
        console.error("Webtool_API_MatrixView_WSY__CommitRowNotes failed", detail);
        this.showToast({
            title: this.translate("OM_Matrix__CommitError"),
            iconClass: "fas fa-times-circle w3-text-red",
            timeout: "permanent"
        });
        // Dirty bleibt bestehen -> Buttons aktiv, Felder behalten ihre Eingabe -> erneutes Speichern moeglich
    }

    // Anmerkungsfelder auf den gespeicherten Stand zuruecksetzen (Verwerfen). Es wurde nichts geschrieben,
    // daher genuegt es, die Edit-Felder auf yItem.note zu setzen und das Staging zu leeren.
    _revertNotes(): void {
        for (let id in this._dirtyNotes) {
            let e = this._dirtyNotes[id];
            e.noteEdit.setValue(e.yItem.note || "", true);   // ohne change-Event
        }
        this._dirtyNotes = {};
        this.selectionStateManager.setNotesDirty(false);
    }

    private __xScrollContainerTimeout;
    private __yScrollContainerTimeout;
    private __handleScrollTimeout;

    _onScroll_Y_axis(evt): void {

        let scrollTop = evt.target.scrollTop;

        this.notes_Axis.scrollTop = evt.target.scrollTop;   // Anmerkungsspalte folgt den Zeilen (sofort, damit sie nicht nachzieht)


        //	scroll-sync asynchonisieren damit sich das nicht gegenseitig ausbremset wenn mit dem Mausrad gescrollt wird
        //
        if (this.__yScrollContainerTimeout) clearTimeout(this.__yScrollContainerTimeout);
        this.__yScrollContainerTimeout = setTimeout(lang.hitch(this, function () {
            this.y_Axis_VirtualScrollContainer.scrollTop = evt.target.scrollTop;
        }), 200);


        if (this.__handleScrollTimeout) clearTimeout(this.__handleScrollTimeout);

        this.__handleScrollTimeout = setTimeout(lang.hitch(this, this._handleYScroll, evt), 200);
    }

    private _previousHandledScrollTop: number = -1;
    private _previousRenderedIndexY: number = -1;   // Flicker-Guard: letzter gerenderter Y-Startindex
    _handleYScroll(evt: MouseEvent, targetScroll?: number) {

        let scrollTop = this.y_Axis.scrollTop;
        let cellHeightWithBorder = this.cellHeight + this.getCellBorderHeight();
        let evtTarget = evt.target as HTMLElement;
        let evtScrollTop = evtTarget.scrollTop;

        

        //console.debug("_handleYScroll", evt, scrollTop, evtScrollTop, this._previousHandledScrollTop);

        //if (this._previousHandledScrollTop == this.y_Axis.scrollTop) return;
        this._previousHandledScrollTop = this.y_Axis.scrollTop;
        
        let calculatedIndex = Math.round(scrollTop / cellHeightWithBorder);

        // Snap auf Zellgrenze -- aber nur schreiben wenn noetig. Ein programmatisches scrollTop-Set
        // feuert _onScroll_Y_axis erneut -> zweiter Repaint (Flicker). Kein Write => kein Echo.
        let snapTop = calculatedIndex * cellHeightWithBorder;
        if (Math.abs(this.y_Axis.scrollTop - snapTop) >= 1) {
            this.y_Axis.scrollTop = snapTop;   // korrigiert auch Sub-Cell-Scroll zurueck auf die Reihe
        }

        // Echo-Guard: selber Startindex -> kein zweiter calc/Repaint/Opacity-Flash.
        if (calculatedIndex === this._previousRenderedIndexY) {
            return;
        }
        this._previousRenderedIndexY = calculatedIndex;

        let itemIndex_firstItem = calculatedIndex;

        // aber der berechnete Startindex stimmt nicht, wenn es darüber zugeklappte Elemente gibt
        // die Scrollposition kann nicht berücksichtigen, wenn ihr Rows fehlen die zugeklappt sind
        // d.h. wenn hier rauskommt wir sind in Reihe 10, dann müssen wir zuerst in der Registry prüfen wie viele Reihen Gruppen sind und was davon zugeklappt ist.
        // das kommt als Offset oben drauf
        let count = 0;
        let index = 0;
        for (let entry of this._registry_Y) {
            if (index < itemIndex_firstItem) {
                if (entry.type == "group" && entry.collapsed === true) {
                    itemIndex_firstItem += Object.keys(entry.children).length;
                }
                index++;
            } else {
                break;
            }
        }

        let firstItem = this._registry_Y[itemIndex_firstItem];
        let lastItem = this._registry_Y[Math.min(itemIndex_firstItem + this.maxRows, this._registry_Y.length - 1)];



        this.calcVisibleIds_Y(itemIndex_firstItem);

        

        // scroll-step anpassen damit immer zu ganzem item gescrollt wird und nie nur ein halbes sichtbar ist
        // hier sollte noch das delta zum vorherigen scroll berechnet werden damit auch der klick auf den balken-pfeil geht
        //
        if (this.__mapContentTimeout) {
            clearTimeout(this.__mapContentTimeout);   // richtigen Timer clearen (war __yScrollContainerTimeout)
        }

        this.UiModder.domStyle.set(this.containerNode, "opacity", 0.2);
        this.__mapContentTimeout = setTimeout(lang.hitch(this, function () {
            this.mapDataToViewPort();
        }), 50);

        this._resetContentOpacity();
    }

    private _incrementUniqueColorIndex(): void {
        if (this.uniqueColorIndex >= this.uniqueColors.length - 1) {
            this.uniqueColorIndex = 0;          // wrap nach 15 verschiedenen Paaren
        } else {
            this.uniqueColorIndex++;
        }
    }

    // pairKey -> color (global über die gesamte Matrix, nicht pro Gruppe)
    private _pairColors: Map<string, string> = new Map();

    // Hilfsfunktion: normalisiert ein Paar (reihenfolgeunabhängig)
    private _pairKey(a: number | string, b: number | string): string {
        const sa = String(a);
        const sb = String(b);
        return sa < sb ? `${sa}|${sb}` : `${sb}|${sa}`;
    }

    private _getIndividualColorForContentItem(item: OrchestraMatrixWsy_DataItem_Content): string | null {
        const counterpart = this._getCounterpartX(item);
        if (counterpart == null) return null;                 // kein Tausch-Paar -> keine Einzelfarbe

        // reihenfolgeunabhängiger Schlüssel -> beide Zellen eines Paares teilen denselben Key
        const pairKey = this._pairKey(item.ref_x, counterpart);

        // 1) Item trägt schon eine Farbe -> Map pflegen und verwenden
        if (item.individualColor != null) {
            if (!this._pairColors.has(pairKey)) this._pairColors.set(pairKey, item.individualColor);
            return item.individualColor;
        }

        // 2) Farbe für dieses Paar schon vergeben? (auch die Gegenstelle nutzt denselben pairKey)
        const existing = this._pairColors.get(pairKey);
        if (existing) {
            item.individualColor = existing;
            return existing;
        }

        // 3) Neue Farbe global zuteilen und merken
        this._incrementUniqueColorIndex();
        const newColor = this.uniqueColors[this.uniqueColorIndex];
        item.individualColor = newColor;
        this._pairColors.set(pairKey, newColor);
        return newColor;
    }

    /**
     * Hilfsfunktion, die die "Gegenstelle" eines Items bestimmt:
     * - bei Replacement: ref_replacement_musican.value
     * - bei Scheduled:   ref_scheduled_musican.value
     * - sonst: null
     */
    private _getCounterpartX(item: OrchestraMatrixWsy_DataItem_Content): number | string | null {
        if (item?.ref_replacement_musican?.value != null) {
            return item.ref_replacement_musican.value;
        }
        if (item?.ref_scheduled_musican?.value != null) {
            return item.ref_scheduled_musican.value;
        }
        return null;
    }

    resetContentArea(): void {
        // der effektive rowindex ist der index der Zeilen im Content-bereich
        // dieser weicht vom visibleRoIndex ab weil diese durch ein/ausblenden der elemente verändert werden
        //
        let effectiveRowIndex = 0;
        let pending = this.selectionStateManager.stack.length > 0;

        console.log("resetContentArea", this._visibleItems_Y, );

        //	alle sichtbaren Y-Items von oben nach unten durchlaufen
        //
        for (let visibleRowIndex in this._visibleItems_Y) {
            let item_Y_check = this._visibleItems_Y[visibleRowIndex];
            let item_Y = this._visibleItems_Y[effectiveRowIndex];
            let row = this._gridRows[effectiveRowIndex];

            if (item_Y_check.invisible === true || !row) {
                continue;
            }



            // dann von links nach rechts die cells
            //
            let effectiveCellIndex = 0;
            for (let visibleCellIndex = 0; visibleCellIndex < this._registry_X.length; visibleCellIndex++) {

                let cellEntry = row.cells[effectiveCellIndex];
                if (!cellEntry) break;   // Pool erschoepft (mehr Spalten als maxCells) -> rechts abgeschnittene Spalten nicht rendern statt zu werfen
                let cellNode = cellEntry.cellNode;
                let item_X = this._visibleItems_X[visibleCellIndex];

                this.UiModder.domClass.remove(cellNode, "selectableCell groupCell");
                this.UiModder.domStyle.set(cellNode, "filter", "");   // Blur vom recycelten Pool-Node immer zuruecksetzen
                this.UiModder.domStyle.set(cellNode, "fontSize", ""); // Schrift des recycelten Pool-Nodes auf Default zuruecksetzen (lange Codes s.u.)

                if (item_X?.invisible === true) {
                    continue;
                }

                let selectionItem = this._getSelectionData(item_X, item_Y_check);

                if (selectionItem) {
                    try {

                        let cellNode = cellEntry.cellNode;
                        cellNode.innerHTML = selectionItem.label;

                        // Lange Codes (z.B. "XE-V") passen nicht in die 35px-Zelle und werden von der
                        // Nachbarzelle ueberdeckt -> Schrift skalieren (kein Tooltip, siehe Kontextmenue).
                        let lbl = selectionItem.label || "";
                        if (lbl.length >= 4) {
                            cellNode.style.fontSize = "12px";   // "XE-V" passt bei 12px (Firefox clippt erst bei 14px -> Reserve)
                        } else if (lbl.length === 3) {
                            cellNode.style.fontSize = "13px";
                        }
                        // len <= 2: Default (durch Pool-Reset oben bereits "")

                        let bIsGroup = false;

                        selectionItem.individualColor = this._getIndividualColorForContentItem(selectionItem);
                        if (selectionItem.individualColor == null) {
                            if (selectionItem.label == "X") {
                                ColorHelpers.colorNode(cellNode, null, ColorHelpers.getHexColorFromString(selectionItem.color));
                                //cellNode.style.background = selectionItem.color;
                            } else {
                                if (item_X.type == "group" || item_Y_check.type == "group") {
                                    //cellNode.style.background = this.colors["group"];
                                    ColorHelpers.colorNode(cellNode, null, this.colors["group"]);
                                } else {
                                    cellNode.style.background = "";
                                }
                            }

                        } else {
                            //cellNode.style.background = selectionItem.individualColor;
                            ColorHelpers.colorNode(cellNode, null, selectionItem.individualColor);
                        }

                        cellEntry.entity = selectionItem;

                        if (item_X.type == "group" || item_Y.type == "group") {
                            bIsGroup = true;
                            cellEntry.type = "group"; // wenn X oder Y eine gruppe sind, dann ist der Schnittpunkt auch eine gruppe
                        }
                        this.UiModder.domClass.toggle(cellEntry.cellNode, "groupCell", bIsGroup);
                        this.UiModder.domClass.add(cellNode, "selected");

                    } catch (ex) {
                        //console.error(ex, "visibleIndex_Y", visibleIndex_Y, "visibleIndex_X", visibleIndex_X);
                    }

                } else if (item_X) {
                    let bIsGroup = false;
                    let bIsClickableCell = false;

                    if (item_X.type == "group" || item_Y_check.type == "group") {
                        bIsGroup = true;
                        cellNode.innerText = "";
                        //cellNode.style.background = this.colors["group"];
                        ColorHelpers.colorNode(cellNode, null, this.colors["group"]);
                        //this.UiModder.domClass.add(cellNode, "selected");
                    }
                    else if (item_X.type == "number") {
                        this.UiModder.domConstruct.create("input", {
                            "type": "text", "maxlength": 2,
                            "style": {
                                "width": "100%"
                            }
                        }, cellNode);
                        //cellNode.style.background = "";
                        ColorHelpers.colorNode(cellNode, null, null);
                        this.UiModder.domClass.remove(cellNode, "selected");
                    }	// entity
                    else {
                        cellNode.innerText = "";
                        //cellNode.style.background = "";
                        this.UiModder.domClass.remove(cellNode, "selected");
                        ColorHelpers.colorNode(cellNode, null, this.colors["entity"]);
                        bIsClickableCell = true;
                    }
                    this.UiModder.domClass.toggle(cellNode, "groupCell", bIsGroup);
                    this.UiModder.domClass.toggle(cellNode, "selectableCell", bIsClickableCell);

                    cellEntry.entity = null;
                }

                // Blur-Cue = Schatten der groupCell-Klasse, nur solange ungespeicherte Aenderungen offen sind
                if (pending
                    && this.UiModder.domClass.contains(cellNode, "groupCell")
                    && cellEntry.entity?.static !== true) {
                    this.UiModder.domStyle.set(cellNode, "filter", "blur(2px)");
                }

                effectiveCellIndex++;
            }

            effectiveRowIndex++;
        }

        this.drawSumRows();
    }

    private _getSelectionData(pItem_X: OrchestraMatrixWsy_DataItem_X, pItem_Y: OrchestraMatrixWsy_DataItem_Y): OrchestraMatrixWsy_DataItem_Content {

        if (!pItem_X || !pItem_Y) {
            return null;
        }

        for (let selectionItemIndex = 0; selectionItemIndex < this._data_Content.items.length; selectionItemIndex++) {
            let selectionEntity = this._data_Content.items[selectionItemIndex];

            if (selectionEntity.ref_x == pItem_X.ID && selectionEntity.ref_y == pItem_Y.ID) {
                return selectionEntity;
            }
        }
    }

    mapDataToViewPort(): void {
        if (this._data_Content == null) {
            return;
        }
        // alles alte löschen
        //

        //this.calcVisibleIds();
        this.resetContentArea();



    }

    destroyAllRows(): void {
        query(".matrixRow", this.containerNode).forEach(function (rowNode) {
            query(".matrixCell", this.containerNode).forEach(function (cellNode) {
                this.UiModder.domConstruct.destroy(cellNode);
            }, this);
            this.UiModder.domConstruct.destroy(rowNode);
        }, this);
    }

    getViewPortSize(): dojo.DomGeometryBox {
        return domGeom.getMarginBox(this.viewPortNode);
    }

    getCellBoldBorderStyleString(position): any {
        return this.cellBorderBold[position] + "px " + this.cellBorderBold["style"] + " " + this.cellBorderBold["color"];
    }
    getCellBorderStyleString(position): any {
        return this.cellBorder[position] + "px " + this.cellBorder["style"] + " " + this.cellBorder["color"];
    }

    getCellBorderWidth(): number {
        return this.cellBorder["left"] + this.cellBorder["right"];
    }

    getCellBorderHeight(): number {
        return this.cellBorder["top"] + this.cellBorder["bottom"];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        //this.inherited(arguments);

        this.selectionStateManager.placeAt(this.mainMenuGlobalSpaceNode);
        this.selectionStateManager.on("rollback", lang.hitch(this, this.selectionStateManager_Rollback));
        this.selectionStateManager.on("commit", lang.hitch(this, this.selectionStateManager_Commit));
        this.selectionStateManager.on("beforeCommit", lang.hitch(this, this.selectionStateManager_BeforeCommit));

        // Kopf der Anmerkungsspalte (Uebersetzung erst hier verfuegbar)
        this.notes_Header.innerHTML = this.translate("OM_Matrix__Note_ColumnHeader");

        //	overflow vom body entfernen damit die ganze seite nicht am body scrollt
        //
        //window.document.body.style.overflow = "hidden";
    }
}

mdsLazyProto(OrchestraMatrixWsy.prototype, {
  selectionStateManager: () => (new SelectionStateManagerV2()),
});
export default mdsWidget(OrchestraMatrixWsy);